import {
    BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS
} from '../../../../../../features/topics/components/edit-topic/constants/i18n/BasicTopicDetailsSectioni18nConstants';

export const BASIC_TOPIC_DETAILS_SECTION_I18N_EN = {
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.topic_name]:          "Topic Name",
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.description]:         "Description",
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.no_description_text]: "-",
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.categories]:          "Categories",
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.email_when_ready]:    "Email When Ready?",
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.yes]:                 "Yes",
  [BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS.no]:                  "No"
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/edit-topic/basic_topic_details_section.i18n.en.js